import * as React from 'react'
import { connect } from 'react-redux'
import { environmentSelected, loadLogPointsLanding, resourceSelected, versionSelected, viewLogPoints } from './actions'
import { SupportedRuntimesTooltipResolver } from '../../../util/SupportedRuntimesHelper'
import { transformToEnvironmentSelectorProps } from '../../../common/environment/model'
import { transformToResourceSelectorProps } from '../../../common/resource/model'
import { transformToVersionSelectorProps } from '../../../common/version/model'
import { LogPointsLandingSvg } from './LogPointsLandingSvg'
import { AppState, Dispatch } from '../../../types'
import MonitoringLandingPage, { ValueProps, EventProps } from '../../../common/components/MonitoringLandingPage/MonitoringLandingPage'
import selectors from '../LogPointsPage/selectors'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'

const mapStateToProps = (state: AppState): ValueProps => {
  return {
    title: 'Log points',
    subTitle: window.mc.featureFlags.logPoints.applications.enabled === 'true' ?
      'Log points allow you to enable and disable logging for your APIs and applications without the need to write code or redeploy. ' +
      'Simply select a resource to configure what to log.' :
      'Log points allow you to enable and disable logging for your API without the need for writing code or redeploying the API. ' +
      'Just select and API to configure what you want to be logged.',
    footer: <SupportedRuntimesTooltipResolver/>,
    image: <LogPointsLandingSvg/>,
    environmentSelector:
      transformToEnvironmentSelectorProps(selectors.landingPage.environmentSelector.getAll(state), 25, 'log-points-environment-selector'),
    resourceSelector:
      transformToResourceSelectorProps(selectors.landingPage.resourceSelector.getAll(state), 40, 'log-points-resource-selector'),
    versionSelector:
      transformToVersionSelectorProps(selectors.landingPage.versionSelector.getAll(state), 35, 'log-points-version-selector'),
    testIds: {
      title: 'log-points-landing-title',
      subTitle: 'log-points-landing-description',
      image: 'log-points-landing-image',
      footer: ''
    }
  }
}

const mapDispatchToProps = (dispatch: Dispatch): EventProps => ({
  componentWillMount: () => dispatch(loadLogPointsLanding()),
  environmentSelected: (environmentId: string) => dispatch(environmentSelected(environmentId)),
  resourceSelected: (resourceId: string, resourceType: ResourceType) => dispatch(resourceSelected(resourceId, resourceType)),
  versionSelected: (versionId: string) => dispatch(versionSelected(versionId)),
  onView: (environmentId: string, resourceId: string, versionId: string) => dispatch(viewLogPoints(environmentId, resourceId, versionId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MonitoringLandingPage)
